export default "__VITE_ASSET__DgjyEa7E__"